import request from '@/plugin/axios'

export function orderList (data) {
  return request({
    url: '/api/admin/orderList',
    method: 'get',
    params: data
  })
}
export function orderDetail (data) {
  return request({
    url: '/api/admin/orderDetail',
    method: 'get',
    params: data
  })
}
export function refundRecordList (data) {
  return request({
    url: '/api/admin/refundRecordList',
    method: 'get',
    params: data
  })
}
export function refundOrderApprovate (data) {
  return request({
    url: '/api/admin/refundOrderApprovate',
    method: 'post',
    data: data
  })
}

export function businessStatistics (data) {
  return request({
    url: '/api/admin/businessStatistics',
    method: 'get',
    params: data
  })
}
